<template>
  <div>
    <div class="gl_title_bar marginBottom10">
      <div class="gl_tb_left">
        <span class="normaltitle">账号管理</span>
      </div>
    </div>
    <div class="top"
         style="cursor:pointer"
         @click="IsBinding=true">
      <img src="../../assets/img/icon/jia2.png"
           alt="">
      <span>绑定账号</span>
    </div>
    <div class="listbox">
      <table>
        <thead>
          <tr>
            <th>序号</th>
            <th>账号</th>
            <th>绑定时间</th>
            <th>权限</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item,index) in storeList"
              :key="index">
            <td>{{pageSize*(pageIndex-1)+index+1}}</td>
            <td>{{item.mobile}}</td>
            <td>{{item.createTime}}</td>
            <td>{{item.menuNames}}</td>
            <td>
              <span style="color:#0B8586;cursor:pointer"
                    @click="getDistributionList(item.to_user_id,item.to_user_type,item.id,item.userId)">分配权限 </span>
              <span style="color:#0B8586;cursor:pointer"
                    @click="unbundling(item.mobile,item.to_user_type,item.id)">解绑</span>
            </td>
          </tr>
          <tr v-show="storeList.length<1">
            <td colspan="5">暂无账号信息</td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination :total="pageCount"
                :limit="pageSize"
                :page="pageIndex"
                @page-change="pageChange"></pagination>
    <el-dialog :visible.sync="IsDistribution"
               class="distribution"
               width="576px">
      <el-form label-width="82px">
        <el-form-item label="分配权限：">
          <el-cascader :options="distributionOptions"
                       placeholder="请选择权限"
                       :props="props"
                       collapse-tags
                       v-model="distributionstr"
                       style="width: 390px;"
                       clearable></el-cascader>
        </el-form-item>
        <el-form-item>
          <div class="xzbtn"
               @click="toDistribution">确认</div>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :visible.sync="IsBinding"
               :show-close="false"
               class="binding"
               width="461px">
      <el-form>
        <el-form-item v-show="!IsBindingPeoed">
          <el-input placeholder="请输入手机号"
                    prefix-icon="el-icon-search"
                    class="cltinput"
                    v-model="clinput2">
            <el-button style="background: #0B8586;"
                       class="bindingSearch"
                       slot="append"
                       @click="getBindingPeo">搜索</el-button>
          </el-input>
        </el-form-item>
        <div v-show="IsBindingPeo"
             style="lin-height:20px;text-align: center;width:100%">未找到相关用户</div>
        <div v-show="!IsBindingPeo&&IsBindingPeoed"
             class="BindingPeo">已查找到账号为<span style="color:#0B8586">{{clinput2}}</span>的用户，请您确定是您要绑定的账号！</div>
        <el-form-item>
          <div class="BindingBot">
            <div class="bindingBtn"
                 style="background: #0B8586;color:#fff"
                 @click="toBinding">确认绑定</div>
            <div class="bindingBtn"
                 @click="BindingNo">取消</div>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'usUpdateProject',
  data () {
    return {
      storeList: [],
      pageCount: 0,
      pageSize: 6,
      pageIndex: 1,
      IsDistribution: false,
      distribution: '',
      props: {
        multiple: true,
        value: 'id',
        label: 'name'
      },
      distributionOptions: [],
      uid: 0,
      distributionstr: [],
      IsBinding: false,
      IsBindingPeo: false,
      IsBindingPeoed: false,
      clinput2: '',
      BindingId: '',
      to_user_id: 0,
      to_user_type: 1
    };
  },
  created () {
    this.to_user_id = Number(localStorage.getItem('storeId'))
    this.to_user_type = Number(localStorage.getItem('storeType'))
    this.GetMyStoreList()
  },
  methods: {
    GetMyStoreList () {
      this.httphelper.post('/api/EnterpriseApi/GetUserbindingList', {
        type: 1,
        businesId: Number(localStorage.getItem('storeId')),
        page: this.pageIndex,
        limit: this.pageSize
      })
        .then(res => {
          if (res.data.code == 200 && res.data.data.length > 0) {
            this.storeList = res.data.data.reverse()
            this.pageCount = res.data.totalcount
          }
        });
    },
    pageChange (page) {
      if (page == this.pageIndex) {
        return;
      }
      this.pageIndex = page;
      this.GetMyStoreList()
    },
    toDistribution () {
      if (this.distributionstr == '') return this.$message.warning('请选择权限');
      this.distribution = ''
      for (let a = 0; a < this.distributionstr.length; a++) {
        if (this.distribution == '') {
          if (this.distributionstr[a].length > 1) this.distribution = this.distributionstr[a][1]
          else this.distribution = this.distributionstr[a][0]
        } else {
          if (this.distributionstr[a].length > 1) this.distribution += ',' + this.distributionstr[a][1]
          else this.distribution += ',' + this.distributionstr[a][0]
        }
      }
      this.httphelper.post('/api/EnterpriseApi/SaveCollegJurdMenu', {
        gubId: this.uid,
        menuIds: this.distribution.toString(),
        addUserID: Number(JSON.parse(localStorage.getItem('ResData')).id)
      })
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success('分配成功');
            this.GetMyStoreList()
            this.IsDistribution = false
          }
        });
    },
    getDistributionList (id, type, uid, userid) {
      this.httphelper.post('/api/EnterpriseApi/GetCollegMenuList', {
        userId: userid,
        to_user_id: id,
        to_user_type: type
      })
        .then(res => {
          if (res.data.code == 200) {
            this.distributionstr = []
            for (let a = 0; a < res.data.data.length; a++) {
              if (res.data.data[a].children.length > 0) {
                for (let b = 0; b < res.data.data[a].children.length; b++) {
                  this.distributionstr.push([res.data.data[a].id, res.data.data[a].children[b].id])
                }
              } else {
                this.distributionstr.push([res.data.data[a].id])
              }
            }
          }
        });
      this.httphelper.get('/api/EnterpriseApi/GetMenuList', {
        type: type
      })
        .then(res => {
          if (res.code == 200) {
            this.IsDistribution = true
            this.uid = uid
            this.distributionOptions = []
            for (let a = 0; a < res.data.length; a++) {
              if (res.data[a].children.length > 0) {
                this.distributionOptions.push({
                  id: res.data[a].id,
                  name: res.data[a].name,
                  children: []
                })
                for (let b = 0; b < res.data[a].children.length; b++) {
                  this.distributionOptions[a].children.push({
                    id: res.data[a].children[b].id,
                    name: res.data[a].children[b].name
                  })
                }
              } else {
                this.distributionOptions.push({
                  id: res.data[a].id,
                  name: res.data[a].name
                })
              }
            }
          }
        });
    },
    getBindingPeo () {
      if (!(/^1[3456789]\d{9}$/.test(this.clinput2))) return this.$message.warning('请输入正确的手机号');
      this.httphelper.post('/api/EnterpriseApi/Register', {
        mobile: this.clinput2.toString(),
      })
        .then(res => {
          if (res.data.data == null) {
            this.IsBindingPeoed = false
            this.IsBindingPeo = true
          } else {
            this.BindingId = res.data.data.id
            this.IsBindingPeoed = true
            this.IsBindingPeo = false
          }
        });
    },
    toBinding () {
      if (this.IsBindingPeoed == false) return this.$message.warning('请先搜索用户');
      this.httphelper.post('/api/EnterpriseApi/SaveUserbinding', {
        userId: this.BindingId,
        to_user_id: this.to_user_id,
        to_user_type: this.to_user_type,
        isStart: true
      })
        .then(res => {
          this.IsBinding = false
          if (res.data.code == 200) {
            this.$message.success('绑定成功');
            this.GetMyStoreList()
          } else if (res.data.code == 500) {
            this.$message.warning('该账户已被绑定，请勿重复绑定！');
          } else {
            this.$message.warning('绑定失败');
          }
        });
    },
    unbundling (name, type, id) {
      this.$confirm('确定要将' + name + '解除绑定吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.httphelper.post('/api/EnterpriseApi/DelUserbinding', {
          gubId: id,
          type: type
        })
          .then(res => {
            if (res.data.code == 200) {
              this.$message({
                type: 'success',
                message: '解绑成功!'
              });
              this.GetMyStoreList()
            } else {
              this.$message({
                type: 'error',
                message: '解绑失败'
              });
            }
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消移除'
        });
      });
    },
    BindingNo () {
      this.IsBinding = false;
      this.clinput2 = ''
      this.IsBindingPeoed = false
      this.IsBindingPeo = false
    }
  }
}
</script>

<style scoped>
.top {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 30px 0;
    width: 85px;
}
.top img {
    width: 17px;
    height: 17px;
    margin-right: 10px;
}
.top span {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
}
.listbox {
    width: 100%;
}
.listbox table {
    width: 100%;
    border-collapse: collapse;
}
.listbox th {
    height: 44px;
    background-color: #0b8586;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    border-color: #e2e2e2;
    border: 1px solid #e2e2e2;
}
.listbox td {
    height: 58px;
    background-color: #0b8586;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    background: #fafafa;
    text-align: center;
    border: 1px solid #e2e2e2;
}
.distribution ::v-deep .el-dialog {
    padding: 50px 52px;
    height: 259px;
    border-radius: 10px;
}
.distribution ::v-deep .el-dialog__body {
    padding: 0;
}
.xzbtn {
    margin-top: 25px;
    margin-left: 64px;
    width: 200px;
    height: 40px;
    background: #0b8586;
    border-radius: 18px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
}
.binding ::v-deep .el-dialog__header {
    display: none;
}
.binding ::v-deep .el-dialog__body {
    padding: 62px 57px 32px;
}
.bindingSearch {
    border: none;
    width: 106px;
    height: 40px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff !important;
}
.BindingBot {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 40px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 40px;
    text-align: center;
}
.bindingBtn {
    width: 150px;
    height: 40px;
    background: #cccccc;
    border-radius: 20px;
    margin: 0 5px;
    cursor: pointer;
}
.BindingPeo {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 37px;
}
</style>